import { useInfiniteQuery } from '@tanstack/react-query';

import { getUserListInfinity } from '@/apis/user';
import type { UserListRequestParams } from '@/chat-types/model/user/UserListParams';
import { USER_QUERY_KEYS } from '@/queries/keys';

export const useGetUserListQuery = (params: Partial<UserListRequestParams>) => {
  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useInfiniteQuery(
    [...USER_QUERY_KEYS.list, params],
    ({ pageParam = 0 }) =>
      getUserListInfinity({
        page: pageParam,
        records: params.records || '20',
        searchName: params.searchName,
      }),
    {
      cacheTime: 600000,
      staleTime: 600000,
      suspense: false,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (!lastPage.isLast) {
          return lastPage.nextPage;
        }
        return undefined;
      },
    },
  );

  const list = data?.pages.flatMap((each) => each.data);

  return {
    data: list,
    total: data?.pages[0].total,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  };
};
